import * as _ from "lodash";
import { LIB_PREFIX }
    from "../../TypesAndIdentifiers";
import SequencePaths from "./SequencePaths";
import BaseConfig from "../utils/BaseConfig";
import { Observable } from "rxjs";

export default class SequenceConfig extends BaseConfig {
    public readonly isLibPreloaded = false;
    public readonly libPrefix = LIB_PREFIX;
    public readonly paths: SequencePaths;
    public language = "en"; // TODO: use i18n here
    public languageContent: any;
    public appConfig: any;
    public sequencerObservable: Observable<any> | null;

    /**
     * Creates an instance of SequenceConfig.
     * @param {any} SequenceID contentID @example com.playpower.sequenceTypes.bsnl.click
     * @memberof SequenceConfig
     */
    constructor(type: string, public readonly sequenceProps) {
        super();
        _.assign(this.sequenceProps, { type });
        this.paths = new SequencePaths(this.sequenceProps.type);
    }
}
